/**
 * Content Moderation translation keys (Groups, Communities, Activities, Feed Posts)
 */
const k = (suffix) => `admin.content_moderation_${suffix}`;

export const contentModeration = {
  menu: k("menu"),
  sections: {
    groups: {
      heading: k("groups_heading"),
      search: k("groups_search"),
      view_heading: k("groups_view_heading"),
    },
    communities: {
      heading: k("communities_heading"),
      search: k("communities_search"),
      view_heading: k("communities_view_heading"),
    },
    activities: {
      heading: k("activities_heading"),
      search: k("activities_search"),
      view_heading: k("activities_view_heading"),
    },
    feedPosts: {
      heading: k("feed_posts_heading"),
      search: k("feed_posts_search"),
      view_heading: k("feed_posts_view_heading"),
    },
  },
  list: {
    columns: {
      created_at: k("col_created_at"),
      name: k("col_name"),
      title: k("col_title"),
      category: k("col_category"),
      creator: k("col_creator"),
      type: k("col_type"),
      members: k("col_members"),
      joined: k("col_joined"),
      activity_date: k("col_activity_date"),
      post: k("col_post"),
      status: k("col_status"),
      actions: k("col_actions"),
    },
    status_filter_options: {
      all: k("filter_all"),
      active: k("filter_active"),
      deactivated: k("filter_deactivated"),
    },
    date_from: k("date_from"),
    date_to: k("date_to"),
    clear_filter: k("clear_filter"),
  },
  status: { active: k("status_active"), deactivated: k("status_deactivated") },
  type: { public: k("type_public"), private: k("type_private") },
  actions: {
    view: k("action_view"),
    deactivate: k("action_deactivate"),
    reactivate: k("action_reactivate"),
    delete: k("action_delete"),
  },
  popups: {
    deactivate: {
      heading: k("deactivate_heading"),
      message: k("deactivate_message"),
      reason_placeholder: k("deactivate_reason_placeholder"),
    },
    reactivate: {
      heading: k("reactivate_heading"),
      message: k("reactivate_message"),
    },
    delete: { heading: k("delete_heading"), message: k("delete_message") },
    yes: k("popup_yes"),
    no: k("popup_no"),
    cancel: k("popup_cancel"),
  },
  toast: {
    deactivated: k("toast_deactivated"),
    reactivated: k("toast_reactivated"),
    deleted: k("toast_deleted"),
    failed: k("toast_failed"),
  },
  view: {
    tabs: { details: k("view_tab_details") },
    back: k("view_back"),
    not_found: k("view_not_found"),
    fields: {
      name: k("field_name"),
      title: k("field_title"),
      description: k("field_description"),
      type: k("field_type"),
      category: k("field_category"),
      location: k("field_location"),
      creator: k("field_creator"),
      members: k("field_members"),
      joined: k("field_joined"),
      created_at: k("field_created_at"),
      activity_date: k("field_activity_date"),
      time: k("field_time"),
      status: k("field_status"),
      text: k("field_text"),
      photo: k("field_photo"),
      join_type: k("field_join_type"),
      max_participants: k("field_max_participants"),
      reason: k("field_reason"),
      deactivated_at: k("field_deactivated_at"),
      deactivated_by: k("field_deactivated_by"),
    },
  },
};
